import { auth } from 'api-client';

import PaltaCombo from '@palta-ui/combo';

export default {
  extends: PaltaCombo,
  props: {
    labelKey: {
      default: 'name',
    },
  },
  data() {
    return {
      url: 'plans',
      model: 'plans',
      api: auth,
      itemOptions: {
        itemValueKey: 'name',
      },
    };
  },
};
